import { httpMethods } from "../constants/appConstants";
import { CMS_ERRORS } from "../constants/sentryConstants";
import { captureSentryException } from "../errors/SentryErrors";
import { sendRequest } from "../helper/serviceHandler/handler";

export const getAboutPage = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/about-us`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.ABOUT_PAGE;
    captureSentryException(message, error, code);
    console.error("Error fetching About Page data:", error);

    throw error;
  }
};

export const getHomePage = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/home-page`);
    return response?.data?.data?.attributes;
  } catch (error) {
    const { message, code } = CMS_ERRORS.HOME_PAGE;
    captureSentryException(message, error, code);
    console.error("Error fetching Home Page data:", error);
    throw error;
  }
};

export const getTimeLine = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/time-line`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.TIME_LINE;
    captureSentryException(message, error, code);
    console.error("Error fetching Timeline data:", error);
    throw error;
  }
};

export const getRouteList = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/route-list`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.ROUTE_LIST;
    captureSentryException(message, error, code);
    console.error("Error fetching Route List data:", error);
    throw error;
  }
};

export const getCareersPage = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/careers-page`);
    return response?.data?.data?.attributes;
  } catch (error) {
    const { message, code } = CMS_ERRORS.CAREERS_PAGE;
    captureSentryException(message, error, code);
    console.error("Error fetching Careers Page data:", error);
    throw error;
  }
};

export const getTeamList = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/meet-some-team`);
    return response?.data?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.TEAM_LIST;
    captureSentryException(message, error, code);
    console.error("Error fetching Team List data:", error);
    throw error;
  }
};

export const getOurPeoples = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/our-peoples`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.OUR_PEOPLES;
    captureSentryException(message, error, code);
    console.error("Error fetching Our Peoples data:", error);
    throw error;
  }
};

export const getOurBrands = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/brand-list`);
    return response?.data?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.OUR_BRANDS;
    captureSentryException(message, error, code);
    console.error("Error fetching Our Brands data:", error);
    throw error;
  }
};

export const getFooter = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/footer`);
    return response?.data?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.FOOTER;
    captureSentryException(message, error, code);
    console.error("Error fetching Footer data:", error);
    throw error;
  }
};

export const getTermsConditions = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, "/cms/terms-conditions");
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.TERMS_CONDITIONS;
    captureSentryException(message, error, code);
    console.error("Error fetching Terms & Conditions data:", error);
    throw error;
  }
};

export const getPoliciesPage = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, "/cms/policies-page");
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.POLICIES_PAGE;
    captureSentryException(message, error, code);
    console.error("Error fetching Policies Page data:", error);
    throw error;
  }
};

export const getPolicySubpage = async (slug: string) => {
  try {
    const response = await sendRequest(
      httpMethods.GET,
      `/cms/policy-document?slug=${slug}`
    );
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.POLICY_SUBPAGE;
    captureSentryException(message, error, code);
    console.error(`Error fetching Policy Subpage (${slug}):`, error);
    throw error;
  }
};

export const getBrandData = async (brandId: any) => {
  try {
    const response = await sendRequest(
      httpMethods.GET,
      `/cms/brand?brandId=${brandId}`
    );
    return response?.data?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.BRAND_DATA;
    captureSentryException(message, error, code);
    console.error(`Error fetching Brand Data (brandId: ${brandId}):`, error);
    throw error;
  }
};

export const getContactSection = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/contact-section`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.CONTACT_SECTION;
    captureSentryException(message, error, code);
    console.error("Error fetching Contact Section data:", error);
    throw error;
  }
};

export const getBAC_Brands = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/bac-brand`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.BAC_BRANDS;
    captureSentryException(message, error, code);
    console.error("Error fetching BAC Brands data:", error);
    throw error;
  }
};

export const getStates = async (brandId: any) => {
  try {
    const response = await sendRequest(
      httpMethods.GET,
      `/cms/brand-states?brandId=${brandId}`
    );
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.BRAND_STATES;
    captureSentryException(message, error, code);
    console.error(`Error fetching Brand States (brandId: ${brandId}):`, error);
    throw error;
  }
};

export const getLocations = async (brandId: any, stateId: any) => {
  try {
    const response = await sendRequest(
      httpMethods.GET,
      `/cms/brand-locations?brandId=${brandId}&state=${stateId}`
    );
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.BRAND_LOCATIONS;
    captureSentryException(message, error, code);
    console.error(
      `Error fetching Brand Locations (brandId: ${brandId}, stateId: ${stateId}):`,
      error
    );
    throw error;
  }
};

export const getStateList = async () => {
  try {
    const response = await sendRequest(httpMethods.GET, `/cms/states`);
    return response?.data;
  } catch (error) {
    const { message, code } = CMS_ERRORS.STATE_LIST;
    captureSentryException(message, error, code);
    console.error("Error fetching State List data:", error);
    throw error;
  }
};
